import { Component, OnInit, ViewChild, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAccountPersonRequest, PaymentMethod } from 'src/app/models/PaymentModels';
import { NgForm } from '@angular/forms';
import { PaymentsService } from 'src/app/services/payments.service';
import { ToastrService } from 'ngx-toastr';
import { PhonePipe } from '../../../pipes/phone.pipe';
import * as moment from 'moment';
import { ChannelEvent, ChannelService } from 'src/app/services/channel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AssignPaymentMethodComponent } from '../assign-payment-method/assign-payment-method.component';
import { AddPaymentMethodComponent } from '../add-payment-method/add-payment-method.component';

@Component({
  selector: 'app-add-payment-method-modal',
  templateUrl: './add-payment-method-modal.component.html',
  styleUrls: ['./add-payment-method-modal.component.less']
})
export class AddPaymentMethodModalComponent implements OnInit,AfterViewInit {
  
  @Input() clientId : number;
  @ViewChild('assignPmtForm', {}) assignPmtForm:AssignPaymentMethodComponent;
  @ViewChild('addPmtForm',{}) addPmtForm: AddPaymentMethodComponent;
  @Output() paymentMethodAddFlowComplete: EventEmitter<PaymentMethod> = new EventEmitter();
  aptexxCreatePaymentLink : string;
  iframeLoadCalls: number = 0;
  showButtons : boolean = true;
  currentStage : number = 0;
  paymentMethod : PaymentMethod;
  public get dialogTitle() : string {
    if(this.currentStage == 1) return 'Assign Payment Method';
    else return 'Add Payment Method';
  }
  
  constructor(public modalService: NgbModal, public payments : PaymentsService, private toast : ToastrService, private channels: ChannelService, public sanitizer: DomSanitizer)
  { }

  ngOnInit() {  }
  ngAfterViewInit(): void {
    this.addPmtForm.paymentMethodAddFlowStarted.subscribe((pmt: PaymentMethod) =>{
      this.showButtons = false;
    })
  }

  cancel() : void {
    this.payments.processing = false;
    this.modalService.dismissAll();
  }

  save() : void {
    if(this.currentStage == 0) {
      if(!this.addPmtForm.ngForm.valid) {
        this.toast.error('Validation errors exist.', '', { disableTimeOut: true, closeButton: true }); 
        return;
      }
      this.addPmtForm.save(); 
    } else if(this.currentStage == 1) {
      // Listen for save complete so we can close everything down.
      this.assignPmtForm.paymentAssignComplete.subscribe((scc: boolean)=>{
        this.paymentMethodAddFlowComplete.next(this.paymentMethod);
        this.modalService.dismissAll();
      })
      this.assignPmtForm.save();
    }
  }

  // handles addPmtForm.paymentMethodAddFlowComplete
  addPmtMethodComplete(evt : PaymentMethod){
    console.warn('Add Pmt Method Complete handler fired',evt);
    this.paymentMethod = evt;
    this.currentStage++;
    this.showButtons = true;
  }

}
